import angular = require("angular");
import TPL = require("templates");
import {RsvpController} from "../../modals/rsvp";
import {LoginController} from "../../modals/login";
import {ConfirmController} from "../../modals/confirm";
import {ManageGuestsController} from "../../modals/manageGuests";

export class RsvpDirective {

  template = TPL.contentDirectives.rsvp;
  scope= {
    params: "=params"
  };
  link;

  constructor($modal, session, $location, $rootScope, stripe, notification, $log) {
    var event = session.getData().event;
    $log.debug("Event: " + event);
    $log.debug(event);

    this.link = (scope, el, attrs) => {
        scope.vm = {
          openCancelReservationConfirm: () => {
            var modalView = ConfirmController.openConfirmDeleteReservationModal($modal,
              () => {
                // confirmCallback
                var event = session.getData().event;

                session.deleteReservation(event.uuid).then(() => {
                  modalView.dismiss();
                  notification.success("Reservation deleted");
                }).then(() => {
                  session.loadEvent(event.uuid).then(() => {
                    session.loadMyReservations();
                  })
                });
              },
              () => {
                // cancelCallback
                modalView.dismiss();
              })
          },

          openInviteGuests: () => {
            var event = session.getData().event;
            ManageGuestsController.open($modal, event.uuid);
          },


          getReservationStatus: () => {
            // 0 is not reserved, 1 is pending and 2 is reserved
            var event = session.getData().event;
            var myreservations = session.getData().myReservations;
            var myReservState;

            angular.forEach(myreservations, (value) => {
              if (event && value.event_id == event.id) {
                myReservState = value.state;
              }
            });

            if (!event) {
              return 0;
            }
            
            //if (event.hosted_by_me) {
            if (session.user.user_id == event.created_by_profile.id) {
              return 5;
            }

            if (myReservState) {

              if (myReservState == "pending") {
                return 1;
              } else if (myReservState == "accepted") {
                return 2;
              } else if(myReservState == "rejected") {
                return 6;
              } else if (myReservState != "rejected") {
                return 3;
              }
            }

            if (event.reservations_stats && event.reservations_stats.guests_accepted >= event.number_of_guests_max /*&& event.event_type!="manual_approval"*/) {
              return 4;
            }

            return 0;
          },
          isRsvp: () : boolean => {
            var event = session.getData().event;
            if (event != null) {
              return event.event_type != "manual_approval";
            } else {
              return false;
            }
          },
          isManualApproval: () => {
            var event = session.getData().event;
            if (event != null) {
                return event.event_type == "manual_approval";
            } else {
              return false;
            }
          },
          openRsvpModal: () => {
            if (session.isNotLogging()) {
              scope.vm.currentModal = LoginController.openLoginModal($modal, scope.vm, $rootScope, () => {
                  scope.vm.currentModal = RsvpController.openRsvpModal($modal, scope.vm, session, $location, stripe, notification, $log);
              });
            } else {
              scope.vm.currentModal = RsvpController.openRsvpModal($modal, scope.vm, session, $location, stripe, notification, $log);
            }
          }
        };
    }
  }

  static factory() {
    var tmp = (a, b, c, d, e, f, g) => new RsvpDirective(a, b, c, d, e, f, g);
    tmp.$inject = ["$uibModal", "session", "$location", "$rootScope", "stripe", "Notification", "$log"];
    return tmp;
  }

}



/** WEBPACK FOOTER **
 ** ./src/scripts/directives/content/rsvp.ts
 **/